import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LaboratoryExaminationCertificatesService } from "../../../services/laboratory-examination-certificates.service";
import { LaboratoryExaminationCertificateDto } from "../../../models/laboratory/laboratory-examination-certificate.dto";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { UsersService } from "../../../../admin/users/users.service";
import { forkJoin } from "rxjs";
import { KeyValueObject } from "../../../models/core/KeyValueObject";
import { UserGroupsEnum } from "../../../enums/user-groups-enum";
import { RequestWaterSamplingActsService } from "../../../services/request-water-sampling-acts.service";

@Component({
    selector: 'create-laboratory-examination-certificate',
    templateUrl: './create-laboratory-examination-certificate.component.html',
    styleUrls: ['./create-laboratory-examination-certificate.component.scss']
})
export class CreateLaboratoryExaminationCertificateComponent implements OnInit {

    @Input() requestId: number;

    @Output() onContinueEvent: EventEmitter<LaboratoryExaminationCertificateDto> = new EventEmitter();
    @Output() onCancelEvent: EventEmitter<any> = new EventEmitter<any>();

    dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

    signingUsers: KeyValueObject[] = [];
    certificate: LaboratoryExaminationCertificateDto = new LaboratoryExaminationCertificateDto();

    showCorrectionReason: boolean = false;
    dataSaving: boolean = false;
    verdictRequired: boolean = true;

    constructor(
        private laboratoryExaminationCertificatesService: LaboratoryExaminationCertificatesService,
        private usersService: UsersService,
        private requestWaterSamplingActsService: RequestWaterSamplingActsService
    ) { }

    ngOnInit(): void {
        const laboratoryManagerUsers$ = this.usersService.getUsersByGroup(<number>UserGroupsEnum.laboratoryManagers);
        const laboratoryAdminUsers$ = this.usersService.getUsersByGroup(<number>UserGroupsEnum.laboratoryAdmins);
        const certificateExist$ = this.laboratoryExaminationCertificatesService.checkExistCertificates(this.requestId);
        const remarkDescription$ = this.laboratoryExaminationCertificatesService.getCertificateRemarkDescription(this.requestId);
        const certificateRequring$ = this.requestWaterSamplingActsService.getLaboratoryCertificateRequiring(this.requestId);

        forkJoin([laboratoryManagerUsers$, laboratoryAdminUsers$, certificateExist$, remarkDescription$, certificateRequring$])
        .subscribe(([laboratoryManagerUsers, laboratoryAdminUsers, certificateExist, remarkDescription, certificateRequring]) => {
            this.showCorrectionReason = certificateExist;
            this.verdictRequired = certificateRequring == null || certificateRequring.code != 'not_required';
            this.certificate.indicatorsRemarkDescription = remarkDescription;

            this.signingUsers = laboratoryManagerUsers;
            laboratoryAdminUsers.forEach(x => {
                if (!this.signingUsers.some(u => u.id == x.id)) {
                    this.signingUsers.push(x);
                }
            })
        });
    }

    cancel() {
        this.onCancelEvent.emit();
    }

    saveChanges() {
        this.dataSaving = true;
        this.certificate.requestId = this.requestId;
        this.laboratoryExaminationCertificatesService.create(this.certificate).subscribe(() => {
            this.dataSaving = false;
            this.onContinueEvent.emit(this.certificate);
        });
    } 

    get canSave(): boolean {
        return (this.isNotEmpty(this.certificate.verdict) || !this.verdictRequired) && 
            this.certificate.signingUserId &&
            (!this.showCorrectionReason || this.isNotEmpty(this.certificate.correctionReason));
    }

    isNotEmpty(value: string): boolean {
        return value != null && value.trim() != '';
    }
}